import { QHelpers } from "../helpers";
import { config } from "../../config";
import { getSettingsEconomicPath } from "../../routes/settingsPaths";

const ECONOMIC_MARKET_PATH = "/economic-market";
const RECONNECT_FLAG_KEY = "economic_reconnect";

/** Must match redirect URL registered on the e-conomic app (same as marketplace install). */
export function getEconomicRedirectUrl(): string {
    return process.env.REACT_APP_ECONOMIC_REDIRECT_URL
        || config.INTEGRATION.ECONOMIC.REDIRECT_URL
        || `${window.location.origin}${ECONOMIC_MARKET_PATH}`;
}

export function buildEconomicOAuthUrl(): string {
    return QHelpers.string.generateUrlEconomic(getEconomicRedirectUrl());
}

export function redirectToEconomicOAuth(): void {
    QHelpers.store.sessionStorageSetItem(RECONNECT_FLAG_KEY, "1");
    window.location.href = buildEconomicOAuthUrl();
}

export function consumeEconomicReconnectFlag(): boolean {
    const isReconnect = QHelpers.store.sessionStorageGetItem(RECONNECT_FLAG_KEY) === "1";
    if (isReconnect) {
        QHelpers.store.sessionStorageSetItem(RECONNECT_FLAG_KEY, "");
    }
    return isReconnect;
}

export function getEconomicReconnectReturnPath(): string {
    return `${getSettingsEconomicPath()}?connected=1`;
}

export function maskEconomicToken(token?: string | null, tailLength = 6): string {
    if (!token) {
        return "n/a";
    }

    if (token.length <= tailLength + 4) {
        return `••••${token.slice(-tailLength)}`;
    }

    return `${token.slice(0, 4)}••••${token.slice(-tailLength)}`;
}
